<template>
  <div class="list-page-allergy-pdf pt-3">
    <!-- table form -->
    <div class="homecare-topic-area">
      <div class="page print-info-area fs13 p20 mb-4">
        <PDFHeader :flg="true" :title="$t('allergy')"/>
        <div class="bodyPDF">
          <div class="detail-content-area">
            <div class="pediatric-area">
              <div class="w-100 pediatric-title mb-3" style="margin-bottom: 5px !important;">
                <span>小児用</span>
                <span>入院中のアレルギー対応食について</span>
              </div>
              <p class="mb-2" style="display: flex;">
                <img style="height:20px; width:20px" src="/images/icon_finger.png">
                <span style="padding: 2px 0px 0px 5px;line-height: 20px;">
                  医療安全にご協力お願いします。
                </span>
              </p>
              <p class="mb-3">なお、お子様の好き嫌いに対する対応はしていませんのでご了承ください。</p>
            </div>
            <div class="table-pediatric">
              <table>
                <tr v-for="(row, rowIndex) in tablePediatric" :key="rowIndex">
                  <td
                    v-for="(item, itemIndex) in row"
                    :colspan="item.colSpan"
                    :key="rowIndex+''+itemIndex"
                    :class="(item.isHighLight && item.data) ? 'highlight' : ''"
                  >
                    <span v-if="item.data" :class="item.isHighLight ? 'icon-checkbox-checked' : 'icon-checkbox-uncheck' ">{{item.data}}</span>
                  </td>
                </tr>
              </table>
            </div>
            <div class="nutritionist">
              <h4 class="mb-2">栄養士との面談必須</h4>
              <div id="group-checkbox" style="display: flex;">
                <img style="height: 20px;width: 20px;margin-left: 5px;" src="/images/icon_checkbox_uncheck.png">
                <span class="mr-4" style="padding: 3px 0px 3px 5px;line-height: 15px;">「米」「かつおだし」「その他」に</span>

                <img style="height: 20px;width: 20px;margin-left: 5px;" src="/images/icon_checkbox_checked.png">
                <span style="padding: 3px 0px 3px 5px;line-height: 15px;">をしている</span>
              </div>
            </div>
            <div class="meet-nutritionist">
              <h4 class="mb-2">栄養士との面談</h4>
              <div class="w-100 mb-2" style="display: flex;">
                <img style="height: 20px;width: 20px;margin-left: 5px;" src="/images/icon_checkbox_uncheck.png">
                <span class="mr-4" style="padding: 3px 0px 3px 5px;line-height: 16px;">希望する</span>

                <img style="height: 20px;width: 20px;margin-left: 5px;" src="/images/icon_checkbox_uncheck.png">
                <span style="padding: 3px 0px 3px 5px;line-height: 16px;">希望しない</span>
              </div>
              <p><span>※</span>「栄養士との面談」とは、入院中の食事に対する下記アレルギー項目に関する面談となります。</p>
              <p><span>※</span> なお、「米」「かつおだし」「その他」に該当される方は、個別メニューとなります。その為、詳細な確認が必要となりますので、栄養士との面談を受けて頂くようお願いいたします。</p>
              <p><span>※</span> 看護師からの説明で、年齢に応じた食事や食べたことがない食品について、わからなかった場合にも、面談を希望できます。</p>
            </div>
            <br>
            <div class="nutritionist-notice">
              <h4>大阪母子医療センターにおけるアレルギー対応食について</h4>
              <p>(1)禁止食品を使用した料理および原材料として合有する加工品は除去します。</p>
              <p>(2)原材料としては使用されず、同一製造ラインを使用しているなどの注意喚起のみの加工食品は除去していません。</p>
              <p>(3)「小麦」禁止としても醤油は使用します。「大豆」禁止としても醤油や大豆油は使用します。</p>
              <p>(4)「魚」禁止としてもかつおだしは使用します。</p>
            </div>
            <div class="signature">
              <p>ご協力ありがとうございました。</p>
              <p>医療安全管理室</p>
              <p>栄養管理室</p>
              <p>2022.3改訂</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end table form -->
    <!-- table Prohibited Foods -->
    <div class="homecare-topic-area">
        <div v-for="(table, tableIndex) in tableProhibitedFoodsData" class="page print-info-area fs13 p20 mb-4" :key="tableIndex">
          <PDFHeader :flg="true" :title="$t('allergy')"/>
          <div class="bodyPDF">
            <div class="detail-content-area">
              <p v-if="tableIndex == 0" class="title-table">禁止食品の除去範囲</p>
              <div class="table-prohibited-foods">
                <table>
                  <tr>
                    <th>禁止食品</th>
                    <th>除去範囲・特記事項</th>
                  </tr>
                  <tr
                    v-for="(data, index) in table"
                    :key="tableIndex+''+index"
                    :class="data.isHighLight ? 'highlight' : ''"
                  >
                    <td>{{data.title}}</td>
                    <td>{{data.detail}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
    </div>
    <!-- end table Prohibited Foods -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PDFHeader from '../PDFHeader.vue'
import { updatePageNumber, exportFileToPDF } from '@/js/commons/commons'
export default {
  components: {
    PDFHeader,
  },
  data() {
    return {
      tablePediatric: [
        [{colSpan: 1, data: 'たまご'},{colSpan: 1, data: '牛乳・乳製品'},{colSpan: 1, data: '小麦'},{colSpan: 1, data: '米'},{colSpan: 1, data: 'そば'}],
        [{colSpan: 2, data: '大豆（醤油・大豆油使用）'},{colSpan: 1, data: '豆・大豆'},{colSpan: 1, data: '納豆'},{colSpan: 1, data: 'ナッツ類'}],
        [{colSpan: 1, data: '鶏肉'},{colSpan: 1, data: '豚肉'},{colSpan: 1, data: '牛肉'},{colSpan: 2, data: 'ハム・ウインナー・ベーコン'}],
        [{colSpan: 2, data: '魚（かつおだし使用）'},{colSpan: 1, data: '青魚'},{colSpan: 1, data: '生魚介類'},{colSpan: 1, data: '魚卵'}],
        [{colSpan: 1, data: 'エビ・カニ'},{colSpan: 1, data: 'イカ・タコ'},{colSpan: 1, data: '貝'},{colSpan: 1, data: 'かつおだし'},{colSpan: 1, data: ''}],
        [{colSpan: 2, data: '醤油（小麦・大豆由来）'},{colSpan: 1, data: '大豆油'},{colSpan: 1, data: 'ごま・ごま油'},{colSpan: 1, data: ''}],
        [{colSpan: 2, data: '山芋・長芋・里芋'},{colSpan: 2, data: 'じゃがいも（かたくり粉使用）'},{colSpan: 1, data: ''}],
        [{colSpan: 1, data: 'うり'},{colSpan: 1, data: 'なす'},{colSpan: 1, data: 'たけのこ'},{colSpan: 2, data: 'トマト（ソース使用）'}],
        [{colSpan: 2, data: 'フルーツ現物'},{colSpan: 1, data: '柑橘類'},{colSpan: 1, data: 'キウイ'},{colSpan: 1, data: 'もも'}],
        [{colSpan: 3, data: 'りんご（果肉果汁のみ除去・ソース使用）'},{colSpan: 1, data: 'びわ'},{colSpan: 1, data: 'バナナ'}],
        [{colSpan: 1, data: 'パイナップル'},{colSpan: 4, data: 'ラテックスフルーツ（キウイ・バナナ・いちじく・栗）'}],
        [{colSpan: 5, data: 'その他'}],
      ],
      tableProhibitedFoodsData: [
        [
          {title: 'たまご', detail: '鶏卵を使用した料理及び加工品。※魚卵は使用します。'},
          {title: '牛乳/乳製品', detail: '牛乳、乳製品を使用した料理及び加工品。'},
          {title: '小麦', detail: '小麦製品を使用した料理及び加工品。※小麦以外の麦類は使用。※醤油は使用します。'},
          {title: '大豆（醤油・大豆油使用）', detail: '大豆、大豆製品を使用した料理（枝豆・黒豆など）及び加工品（味噌）。※大豆油と醤油は使用します。'},
          {title: '豆', detail: '大豆、大豆製品とその他の豆。豆製品とその若ざやを使用した料理。※ピーナッツ（落花生）も除去しています　※カカオ豆、コーヒー豆は使用します。'},
          {title: 'ナッツ類', detail: 'ピーナッツ、アーモンドを利用した料理。※栗は使用します。'},
          {title: '鶏肉/豚肉/牛肉', detail: 'それぞれの肉（すべての部位を含む）を使用した料理及び加工品。※ゼラチンは使用します。※コンソメなどに含まれるエキスは使用します。'},
          {title: '魚', detail: '魚全般（魚介類、エビ、カニ、イカ、タコ、魚卵）。※かつお出汁などのエキスは使用します。'},
          {title: '青魚', detail: 'サバ、イワシ、アジ、サンマを使用した料理及び加工品。※しらす干し（鰯の稚魚）は使用します。※エキスは使用します。'},
          {title: '生魚介類', detail: '生の魚介類を使用した料理。'},
          {title: 'エビ/カニ/イカ/タコ', detail: 'エビ、カニ、イカ、タコのそれぞれを使用した料理及び加工品。※しらす干しは稀にエビ、カニ、イカ、タコが混入する可能性があるため除去します。※かつおだし汁などのエキスは使用します。'},
          {title: '貝', detail: '貝を使用した料理及び加工品。エキス使用加工品。'},
          {title: 'かつおだし', detail: 'かつおのエキスが入っているもの。（「魚禁」で魚の出汁も除去が必要な場合）'},
          {title: '醤油（小麦・大豆由来）', detail: '醤油のみ除去します。※小麦・大豆は使用します。'},
          {title: '大豆油', detail: '大豆油を除去します。'},
          {title: 'じゃがいも', detail: 'じゃが芋を使用した料理及び加工品。※じゃが芋でん粉（かたくり粉）とそれを原材料に含有する加工品は使用します。'},
          {title: 'うり', detail: '南瓜、胡瓜、西瓜、メロンとその果汁を使用した料理及び加工品。'},
          {title: 'トマト', detail: 'トマトを使用した料理及び加工品。※ウスターソースは使用します。'},
          {title: 'フルーツ現物', detail: 'トッピングのゆず皮。レモン、すだち等添え物、フルーツ缶、果汁の多いジュース、アイス、デザート。※代替え料理の提供はありません。※ウスターソースは調味料に含まれる果汁は使用します。'},
          {title: '柑橘類/キウイ/もも/りんご', detail: 'それぞれの果実とその果汁を使用した料理及び加工品。※果糖は使用します。※グレープフルーツはネオーラルフルーツに含まれます。'},
          {title: 'バナナ', detail: 'バナナ、バナナを含む加工品。'},
          {title: 'ラテックスフルーツ', detail: 'ラテックスアレルギーとの交叉抗原性があるいちじく、キウイフルーツ、バナナ、栗、マンゴーを使用した料理及び加工品。※パパイヤ、アボガド、くるみは入院食に使用なし。'},
        ],
      ],
    }
  },
  computed: {
    ...mapState({
      childName: state => state.homecare.allergyPdf.child_name,
      allergyData: state => state.homecare.allergyPdf.allergyData,
      allergyOther: state => state.homecare.allergyPdf.allergyOther,
    }),
  },
  created() {
    let listHighLight = []
    this.tablePediatric.forEach((row, rowIndex) => {
      row.forEach((item, index) => {
        if(rowIndex == this.tablePediatric.length - 1) {
          if(this.allergyOther.trim()) {item.isHighLight = true}
          else {item.isHighLight = false}
        }
        else {
          if(
            this.allergyData.includes(item.data.split('（')[0]) ||
            (item.data === '牛乳・乳製品' && item.data.split('・').some(a => this.allergyData.indexOf(a) >= 0))
          ) {
            item.isHighLight = true
            if(item.data.includes('（')) {
              listHighLight.push(item.data.split('（')[0])
            }
            else if(item.data.includes('・')) {
              listHighLight.push(item.data.split('・')[0])
            }
            else {
              listHighLight.push(item.data)
            }
          } 
          else {item.isHighLight = false}
        }
      })
    })
    this.tableProhibitedFoodsData.forEach(table => {
      table.forEach(row => {
        row.title.split('（')[0].split('/').forEach(el => {
          (listHighLight.includes(el.trim()) || row.isHighLight) ? row.isHighLight = true : row.isHighLight = false
        })
      })
    })
  },
  mounted() {
    updatePageNumber()
    exportFileToPDF(this.childName, this.$t('allergy'), 'allergy')
  },
}
</script>
<style scoped>
  .pediatric-area  span{
    font-size: 14px;
  }
  .pediatric-area .pediatric-title span{
    line-height: 40px;
    font-size: 17px;
  }
  .pediatric-area .pediatric-title span:first-child{
    padding: 10px;
    border: 2px solid #FF8EA1;
    font-size: 17px;
    margin-right: 10px;
  }
  .table-pediatric {
    margin-bottom: 10px;
  }
  .table-pediatric tr td {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    border: 0.5px solid #FF8EA1;
    line-height: 30px;
    padding: 1px 10px;
    letter-spacing: 2px;
  }
  .highlight,
  .highlight td {
    background-color: #FFFA90 !important;
  }
  .nutritionist {
    width: 100%;
    height: 65px;
    border: 0.5px solid #FF8EA1;
    padding: 10px;
    margin-bottom: 10px;
  }
  .meet-nutritionist label {
    margin-bottom: 10px
  }
  .meet-nutritionist p span {
    color: red;
    margin-right: 5px;
  }
  .nutritionist-notice h4 {
    color: #FF8EA1;
    margin-bottom: 10px;
  }
  .nutritionist-notice p {
    margin-bottom: 5px;
  }
  .signature {
    margin-top: 10px;
    text-align: right;
  }
  .table-prohibited-foods th {
    text-align: center;
    background-color: #FDF2F2;
    font-weight: 400;
    line-height: 40px;
    border: 0.5px solid #FF8EA1;
    font-size: 14px;
  }
  .table-prohibited-foods tr td {
    height: 30px;
    border: 0.5px solid #FF8EA1;
    padding: 5px 5px;
    width: 564px;
    min-width: 564px;
    max-width: 564px;
  }
  .table-prohibited-foods tr th:first-child,
  .table-prohibited-foods tr td:first-child {
    width: 190px;
    min-width: 190px;
    max-width: 190px;
  }
  .checkbox-parts {
    padding-top: 1px !important
  }
  .bodyPDF {
    font-size: 12px;
  }
</style>